/**
 * Article body read view – web: render HTML when from TinyMCE, else plain text.
 */

import {View} from 'react-native'

import {atoms as a, useTheme} from '#/alf'
import {
  looksLikeHtml,
  sanitizeArticleHtml,
} from '#/screens/Articles/sanitizeArticleHtml'

type Props = {
  content: string
}

export function ArticleBodyView({content}: Props) {
  const t = useTheme()
  const html = content?.trim()
  const isHtml = html && looksLikeHtml(html)
  const safeHtml = isHtml ? sanitizeArticleHtml(html) : ''

  if (isHtml && safeHtml) {
    return (
      <View style={[a.pt_lg]}>
        <div
          className="article-body"
          dangerouslySetInnerHTML={{__html: safeHtml}}
          style={{
            fontSize: 16,
            lineHeight: 1.5,
            color: t.palette.contrast_0 ?? undefined,
          }}
        />
      </View>
    )
  }

  return (
    <View style={[a.pt_lg]}>
      <div style={{fontSize: 16, lineHeight: 1.5, color: t.palette.contrast_0}}>
        {html || ''}
      </div>
    </View>
  )
}
